import React, { FC } from 'react';
import { isCaresTenant } from '@utmb/utils/theme';

interface TenancyContextProps {
    tenantId: string;
}

const TenancyContext = React.createContext({} as TenancyContextProps);

interface TenancyProviderProps {
    tenantId: string;
}

export const TenancyProvider: FC<TenancyProviderProps> = ({ children, tenantId }) => {
    return (
        <TenancyContext.Provider
            value={{
                tenantId,
            }}
        >
            {children}
        </TenancyContext.Provider>
    );
};

/** True when the current tenant is rendered with the UTMB Cares theme (see `@utmb/utils/theme`). */
export const useIsCaresTenant = (): boolean => isCaresTenant(useTenancy().tenantId);

export const useTenancy = () => {
    const context = React.useContext(TenancyContext);
    if (context === undefined) {
        throw new Error(`useTenancy must be used within an TenancyProvider`);
    }
    return context;
};
